module.exports = __webpack_public_path__ + "c3d52d90ef78fc63dd9e9421d8a30f40.png";